export default __webpack_public_path__ + "static/feed-efcccb85707720033d9be2b541fd9466.png";